export const NAME = 'search';
